import { Box, Link, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const APPLE_MUSIC_STYLE_GUIDE_URL =
  'https://help.apple.com/itc/musicstyleguide/en.lproj/static.html';

const Guidelines = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        color: theme.palette.grey[400],
        fontSize: 12,
        lineHeight: 1.67,
      }}
    >
      <Trans
        i18nKey="distribution:guidelines"
        t={t}
        data-testid="distribution-guidelines"
      >
        <Link
          href={APPLE_MUSIC_STYLE_GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
          color={theme.palette.grey[50]}
        />
      </Trans>
    </Box>
  );
};

export default Guidelines;
